import { Injectable } from '@angular/core';
import { APP_ROUTES } from '@app/constants';
import { API_URLS } from '@app/constants/apiUrls';
import { ApiHelper } from '@app/helpers';

@Injectable({
  providedIn: 'root'
})
export class FormGroupService {

  constructor(private apiHelper: ApiHelper) { }

  list(surveyId: string) {
    return this.apiHelper.get(API_URLS.FORM_GROUP, {
      survey: surveyId
    })
  }

  add(payload: any) {
    return this.apiHelper.post(API_URLS.FORM_GROUP, payload)
  }

  update(id: string, payload: any) {
    return this.apiHelper.put(`${API_URLS.FORM_GROUP}/${id}`, payload)
  }

  delete(id: string) {
    return this.apiHelper.delete(`${API_URLS.FORM_GROUP}/${id}`)
  }
}
